import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=06076ee6&scoped=true&"
import script from "./Search.vue?vue&type=script&lang=ts&"
export * from "./Search.vue?vue&type=script&lang=ts&"
import style0 from "./Search.vue?vue&type=style&index=0&id=06076ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06076ee6",
  null
  
)

export default component.exports